import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import DefaultButton from './DefaultButton';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.tertiary.main,
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    }
  }
}));

const FilledButton = props => {
  const { children, className, ...remainingProps } = props;
  const classes = useStyles();
  const classname = className ? clsx(classes.root, className) : classes.root;
  return (
    <DefaultButton className={classname} variant="contained" {...remainingProps}>
      {children}
    </DefaultButton>
  );
};

export default FilledButton;
